import { Locales } from "@/lib/i18n";
import { actions, segments } from "@/locales/segment";

export const authSegments = {
  signup: {
    en: "signup",
    fr: "inscription",
    nl: "registratie",
  },
  login: {
    en: "login",
    fr: "connexion",
    nl: "inloggen",
  },
  "forgot-password": {
    en: "forgot-password",
    fr: "mot-de-passe-oublie",
    nl: "wachtwoord-vergeten",
  },
  "reset-password": {
    en: "reset-password",
    fr: "reinitialiser-le-mot-de-passe",
    nl: "wachtwoord-herstellen",
  },
} as const;

export const authSegmentKeys = Object.keys(authSegments) as (keyof typeof authSegments)[];

export type AuthSegmentKeyType = keyof typeof authSegments;

export const isAuthTemplate = (key: string): key is AuthSegmentKeyType => {
  return key in authSegments;
};

export const isAuthSlug = (resolution: Resolution): boolean => {
  const { templateName, locale, slugs } = resolution;

  // Check if it's a signup template
  if (templateName === "signup") {
    const currentSlug = slugs[0];

    // Check if it's the main signup segment
    if (segments[locale as Locales]?.signup === currentSlug) {
      return true;
    }

    // Check if it's a signup action (verify or confirm)
    const localeActions = actions[locale as keyof typeof actions];
    if (localeActions) {
      return currentSlug === localeActions.verify || currentSlug === localeActions.confirm;
    }
  }

  // Check for login template
  if (isAuthTemplate(templateName)) {
    const currentSlug = slugs[0];
    return currentSlug === authSegments[templateName][locale as Locales];
  }

  return false;
};
